export const useReloadWarning = (reloading?: (arg: boolean) => void) => {
	const isUnloading = shallowRef(false)

	onMounted(() => {
		if (import.meta.client) {
			window.addEventListener('beforeunload', handleBeforeUnload)
			window.addEventListener('unload', handleUnload)
		}
	})

	onUnmounted(() => {
		window.removeEventListener('beforeunload', handleBeforeUnload)
		window.removeEventListener('unload', handleUnload)
	})

	function handleBeforeUnload(event: BeforeUnloadEvent) {
		// This is where you can warn the user before they refresh or close the page
		event.preventDefault()
		event.returnValue = ''
		isUnloading.value = true
	}

	function handleUnload() {
		reloading?.(isUnloading.value)
	}
	return isUnloading
}
